export default __webpack_public_path__ + "static/media/Auto_2.c9e52c4a.JPG";